module.exports = __webpack_public_path__ + "img/805.bd6a617a.png";